module.exports = __webpack_public_path__ + "static/media/silver-card-back.a1892eec.png";